import { dayjs } from '@mobi/utils/date'
import { getFromLocalStorage, setInLocalStorage } from '@mobi/utils/storage'
import { keys as analyticsKeys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

const enum LocalConstants {
  RegisteredTrackingLocalStorageKey = 'featured-tile__viewed_register_tracked',
}

export const trackFeatureItemClicked = (data?: FeatureItemAnalyticsData) => {
  if (!data) return
  const newData = mapBannerDataToEcommerceItems(data)
  trackEvent(analyticsKeys.featureItemClicked, {
    ecommerce: {
      items: [newData],
    },
  })
}

export const trackFeaturedItemViewed = (data?: FeatureItemAnalyticsData) => {
  if (!data) return

  const newData = mapBannerDataToEcommerceItems(data)
  const registeredTrackingData = getRegisteredViewedTiles()
  const tileId = data.featureItemTitle

  if (registeredTrackingData.has(tileId)) return

  trackEvent(analyticsKeys.featureItemBannerViewed, { ecommerce: { items: [newData] } })

  const date30DaysFromNow = dayjs().add(30, 'days')
  registeredTrackingData.set(
    tileId,
    dayjs(data.endDate).isBefore(date30DaysFromNow) ? data.endDate : date30DaysFromNow.toString()
  )
  setRegisteredViewedTiles(registeredTrackingData)
}

// =============
// Local Helpers
// =============

const getRegisteredViewedTiles = (): RegisteredViewTiles => {
  const registeredTrackingData: RegisteredViewTiles = new Map(
    JSON.parse(getFromLocalStorage(LocalConstants.RegisteredTrackingLocalStorageKey) || '[]')
  )
  registeredTrackingData.forEach((endDate, key, map) => {
    if (dayjs(endDate).isBefore(dayjs())) map.delete(key)
  })
  return registeredTrackingData
}

const setRegisteredViewedTiles = (registeredTrackingData: RegisteredViewTiles) => {
  setInLocalStorage(
    LocalConstants.RegisteredTrackingLocalStorageKey,
    JSON.stringify(Array.from(registeredTrackingData.entries()))
  )
}

const mapBannerDataToEcommerceItems = (data: FeatureItemAnalyticsData) => {
  const itemBrand = data.clickUrl.includes('tabtouch-sports')
    ? 'pre'
    : data.clickUrl.includes('races')
      ? 'Racing'
      : undefined
  const itemIdMatch = data.clickUrl.match(/\/event\/(\d+)$/)
  const itemId = itemIdMatch ? itemIdMatch[1] : undefined

  return {
    promotion_name: data.featureItemTitle,
    internalTrackingCode: data.internalTrackingCode,
    item_id: itemId,
    index: data.featureItemPosition,
    item_brand: itemBrand,
    item_variant: 'Feature Tile',
  }
}

// =====
// Types
// =====

type RegisteredViewTiles = Map<string, string>

export interface FeatureItemAnalyticsData {
  featureItemTitle: string
  featureItemPosition: number
  accountNumber: number | null
  internalTrackingCode: string | null
  clickUrl: string
  endDate: string
}
